import React from 'react';
import PortfolioSection from '../components/PortfolioSection';

const PortfolioPage = () => {
  return <PortfolioSection />;
};

export default PortfolioPage;
